import { z } from "zod";
import { CONFIRM_PASSWORD, NEW_PASSWORD } from "./consts";

export const schema = z.object({
  [NEW_PASSWORD]: z.string().min(1, "This field is required"),
  [CONFIRM_PASSWORD]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;